import React, { ReactNode } from 'react';
import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
import { FormButtons } from './FormButtons';

export interface IConfirmDialogProps {
    hidden: boolean;
    title: string;
    content?: string;
    confirmButtonText: string;
    handleConfirm: () => void;
    handleCancel: () => void;
    children?: ReactNode;
    htmlContent?: any;
}

export const ConfirmDialog = ({ hidden, title, content, confirmButtonText, handleConfirm, handleCancel, children, htmlContent }: IConfirmDialogProps): React.ReactElement => {
    return (
        <Dialog hidden={hidden} onDismiss={handleCancel} dialogContentProps={{ type: DialogType.normal, title: title }}>
            {content || children}
            {htmlContent && htmlContent}
            <DialogFooter>
                <FormButtons onPrimaryClick={handleConfirm} onSecondaryClick={handleCancel} primaryText={confirmButtonText} />
            </DialogFooter>
        </Dialog>
    );
};
